import axios from 'axios';

export const requestTipPaymentIntent = (payload: any): Promise<any> =>
  axios.post('v1/tips/web/purchases', payload.toJSON());
